module.exports = __webpack_public_path__ + "img/Tennis.651b8a94.png";